var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1081 0H24C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48H24.1081C37.3629 48 48.1081 37.2548 48.1081 24C48.1081 10.7452 37.3629 0 24.1081 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8361 18.628L34.7358 18.4345L34.5516 18.551C33.6914 19.0948 32.6793 19.3491 31.5943 19.3491C30.5945 19.3491 29.5239 19.0325 28.3716 18.5434C27.4464 18.1507 26.4825 17.6532 25.4702 17.1308C25.2212 17.0023 24.9693 16.8723 24.7144 16.7419C22.1437 15.4279 19.2815 14.0909 16.1422 14.0909C14.3957 14.0909 12.3861 14.6698 10.7978 15.7625L10.6348 15.8747L10.7452 16.0389L12.1679 18.1552L12.278 18.3191L12.4433 18.211C13.8138 17.3145 15.2206 16.8909 16.6893 16.8909C18.3798 16.8909 20.4408 17.7536 22.6177 18.7812V30.48V30.68H22.8177H25.0939H25.2939V30.48V20.0838C26.6976 20.7485 28.1035 21.3692 29.3585 21.7297L29.337 30.4795L29.3365 30.68H29.537H31.8132H32.0132V30.48V22.0288C33.3073 21.9429 34.5692 21.6243 35.7916 20.8761L35.9504 20.7788L35.8648 20.6135L34.8361 18.628Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.913 27.8364C36.1246 27.8364 35.4873 28.4708 35.4873 29.2582C35.4873 30.0456 36.1246 30.68 36.913 30.68C37.6771 30.68 38.3386 30.0479 38.3386 29.2582C38.3386 28.4685 37.6771 27.8364 36.913 27.8364Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.66a50f6722d8b8cbf847493d5cbfa8e4.svg";
export { ForwardRef as ReactComponent };